import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router'
import { useTranslation } from 'react-i18next'
import { useStyletron } from 'baseui'
import { selectAuthData } from '@/containers/Login/AuthSelectors'
import useBusinessType from '@/shared/hooks/useBusinessType'
import { selectOrganizationsGeneral, selectOrganizationsSelectedProvider } from '../organizationsManagementSelectors'
import { organizationsManagementActions } from '../organizationsManagementSagas'

const useHeading = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { t } = useTranslation()
  const [css] = useStyletron()

  const providerGeneral = useSelector(selectOrganizationsGeneral)
  const selectedProvider = useSelector(selectOrganizationsSelectedProvider)
  const { loaderRoutesEnergy, loaderRoutes, loaderRoutesInsurance } = useSelector(selectAuthData)
  const { type } = useBusinessType({
    loaderRoutesEnergy,
    loaderRoutes,
    loaderRoutesInsurance,
    modulesStatuses: {},
    modulesStatusesEnergy: {},
    modulesStatusesInsurance: {},
  })

  const selectedItem = () => {
    const selected = []
    if (!selectedProvider.uuid || providerGeneral.providersList.length <= 0) {
      return selected
    }
    providerGeneral.providersList.map(provider => {
      if (provider.uuid === selectedProvider.uuid) {
        selected.push(provider)
      }
    })
    return selected
  }

  const handleSelectProvider = params => {
    const providerId = params.value[0]?.uuid ?? ''
    if (providerId !== '') {
      dispatch({ type: organizationsManagementActions.LOAD_PROVIDER, providerId })
      navigate('/' + type + '/organisations/provider/' + providerId)
    } else {
      navigate('/' + type + '/organisations/provider')
    }
  }

  const handleEdit = () => navigate('/' + type + '/organisations/provider/edit/' + selectedProvider.uuid)

  const handleDelete = () => {
    if (window.confirm(t('organizationManagement:confirm_provider_deletion'))) {
      dispatch({
        type: organizationsManagementActions.DELETE_PROVIDER,
        providerId: selectedProvider.uuid,
        onSuccess: () => navigate('/' + type + '/organisations/provider'),
      })
    }
  }

  const handleAddOffer = () =>
    navigate('/' + type + '/organisations/provider/' + selectedProvider.uuid + '/offers/add')

  const handleNetting = () =>
    navigate('/' + type + '/organisations/provider/' + selectedProvider.uuid + '/netting')

  const handleAddProvider = () => navigate('/' + type + '/organisations/provider/add')

  return {
    t,
    css,
    providerGeneral,
    selectedProvider,
    selectedItem,
    handleSelectProvider,
    handleEdit,
    handleDelete,
    handleAddOffer,
    handleNetting,
    handleAddProvider,
  }
}

export default useHeading
